import { TEST_MODE } from '../utils'

interface DataObject {
  new_engine?: boolean
  is_test?: boolean
  flows?: any
}

interface Data {
  pageId?: string
  pageIndex?: number
  flowId?: string
  data?: DataObject
  is_test?: boolean
}

declare global {
  interface Window {
    Savvy: { track: () => void }
  }
}

export function track(flowId: string, eventId?: string, data?: Data, isTest?: boolean) {
  if (TEST_MODE) return

  if (!data) data = {}
  data.flowId = flowId
  if (TEST_MODE || isTest) data.is_test = true
  addToAnalyticsQueue('track', eventId, data).then(() => {
    // console.log('Tracked the following event:', eventId, data)
  })
  // .catch((error) => {
  //   console.warn(
  //     'No Savvy Analytics found - failed to track the following event (+ error):',
  //     data,
  //     error
  //   )
  // })
}

export function trackUserData(flowId: string, userData: Record<string, unknown>) {
  if (TEST_MODE) return
  /* If flow does not belong to Savvy group, and not a standalone Flow / deployed, then do not send data */
  const doNotTrack = ['currentPageId', '_source_data']
  const coreFields = ['name', 'email', 'phoneNumber', 'firstName', 'lastName', 'nickname']

  const data: Data = { data: { new_engine: true } }

  if (TEST_MODE || [true, 'true'].includes(userData.is_test as boolean)) {
    data.is_test = true // Savvy Analytics only accepts custom values in data.data for now, so this is lost - hence the 2nd line
    data.data = {}
    data.data.is_test = true
  }

  const set = (key: string, val: unknown) => {
    if (!data.data) data.data = {}
    if (!data.data.flows) data.data.flows = {}
    if (!data.data.flows[flowId]) data.data.flows[flowId] = {}
    data.data.flows[flowId][key] = val
  }

  Object.entries(userData).forEach(([key, val]) => {
    if (doNotTrack.includes(key)) return

    set(key, val)

    if (coreFields.includes(key) && (val || val === false)) data[key] = val
  })

  addToAnalyticsQueue('identify', undefined, data).then(() => {
    // console.log('Identified the user with the following data:', data)
  })
  // .catch((error) => {
  //   console.warn(
  //     'No Savvy Analytics found - failed to identify the user with the following data + error:',
  //     data,
  //     error
  //   )
  // })
}

function addToAnalyticsQueue(methodName: string, ...args: any) {
  return new Promise<void>((resolve, reject) => {
    let attempts = 0

    const done = doIt()
    if (done) {
      return resolve()
    }

    const interval = setInterval(() => {
      const done = doIt()
      if (done) {
        clearInterval(interval)
        return resolve()
      }
      if (attempts > 40) {
        clearInterval(interval)
        return resolve()
        // return reject(
        //   `Savvy Analytics not found on ${window.location.host} - Timed out after 10 seconds`
        // )
      }

      attempts++
    }, 250)

    function doIt() {
      const method = window.Savvy && window.Savvy[methodName]
      if (method) {
        method(...args)
      }
      return Boolean(method)
    }
  })
}
